import http from '../http'

export default {
  listGeoLocations(req) {
    return http.get(`/geolocation/v1/locations/name/${req.name}`, { params: { page: req.page, size: req.size } })
  },

  findGeolocationById(id) {
    return http.get(`/geolocation/v1/locations/${id}`)
  },

  viewTreeRoots(id) {
    return http.get(`/compass-ws-rest/trace/trees/${id}/roots`)
  },

  listRevisionTrees(req) {
    return http.get('/compass-ws-rest/trace/trees', { params: req })
  },

  recallCode(data) {
    return http.post('/recalls/v1/analysis/code', data)
  },

  recallConfirm(id) {
    return http.put(`/recalls/v1/${id}/confirmed`)
  },

  recallReject(id) {
    return http.put(`/recalls/v1/${id}/rejected`)
  },

  getChildrenCodes(code) {
    return http.get(`/compass-ws-rest/children/${code}`)
  },

  getLocation(locationId) {
    return http.get(`/compass-ws-rest/locations/${locationId}`)
  },

  updateLocationContactInformation(locationId, data) {
    return http.put(`/compass-ws-rest/locations/${locationId}/contact`, data)
  },

  getLocationPackageDetails(locationId, packageId) {
    return http.get(`/compass-ws-rest/locationinventory/packagetype/${locationId}/${packageId}`)
  },

  getLocationSoldItems(data) {
    return http.post('/compass-ws-rest/solditems', data)
  },

  getLocationReturnes(locationId, req) {
    return http.get(`/recalls/v1/location/${locationId}/returned`, { params: req })
  },

  getActiveLocationRecalls(locationId) {
    return http.get(`recalls/v1/location/${locationId}/active`)
  },

  getLocationPackageFlow(locationId, req) {
    return http.get(`/compass-ws-rest/packageflow/${locationId}`, { params: req })
  },

  getLocationEvents(locationId, req) {
    return http.get(`/compass-ws-rest/lastlocationevents/${locationId}`, { params: req })
  },

  getLocationPackages(locationId) {
    return http.get(`/compass-ws-rest/locationinventory/packagetype/${locationId}`)
  },

  getLocationProducts(locationId) {
    return http.get(`/compass-ws-rest/locationinventory/product/${locationId}`)
  },

  setChildren(data) {
    return http.put('/compass-ws-rest/trees/children', data)
  },

  appendChildren(data) {
    return http.post('/compass-ws-rest/trees/children', data)
  },

  detachChildren(data) {
    return http({
      url: '/compass-ws-rest/trees/children',
      method: 'DELETE',
      data
    })
  },

  getUploaded(req) {
    return http.get('/supplychain/v1/uploaded/total', { params: req })
  },

  getUploadedInterval(req) {
    return http.get('/supplychain/v1/uploaded/interval', { params: req })
  },

  getEvents(req) {
    return http.get('/supplychain/v1/events', { params: req })
  },

  getEventCount(req) {
    return http.get('/supplychain/v1/eventcount', { params: req })
  },

  findBusinessLocation(id) {
    return http.get(`/masterdata/locations/v1/${id}`)
  },

  listBusinessLocations(req) {
    return http.get('/masterdata/locations/v1', { params: req })
  },

  updateBusinessLocation(id, data) {
    return http.put(`/masterdata/locations/v1/${id}`, data)
  },

  deleteBusinessLocation(id) {
    return http({
      method: 'DELETE',
      url: `/masterdata/locations/v1/${id}`,
      roles: ['ROLE_LOCATION_MANAGER']
    })
  },

  createBusinessLocation(data) {
    return http.post('/masterdata/locations/v1', data)
  },

  registerTrackingEvent(req) {
    return http.post('/track/v1/capture', req)
  },

  getTrackingDispositions(req) {
    return http.get('/track/v1/dispositions', { params: req })
  },

  getTrackingBusinessSteps(req) {
    return http.get('/track/v1/business-steps', { params: req })
  },

  listShipments(req) {
    return http.get('/shipments/v1', {
      params: { sort: 'created,desc', ...req }
    })
  },

  getShipment(id) {
    return http.get(`/shipments/v1/${id}`)
  },

  getShipmentItems(id) {
    return http.get(`/shipments/v1/${id}/items`)
  },

  addShipmentItems(id, codes) {
    return http.post(`/shipments/v1/${id}/items`, codes)
  },

  addShipmentOrderItems(id, data) {
    return http.post(`/shipments/v1/${id}/orderitems`, data)
  },

  createShipment(data) {
    return http.post('/shipments/v1', data)
  },

  closeShipment(data) {
    return http.put('/shipments/v1/closed', data)
  },

  reopenShipment(data) {
    return http.put('/shipments/v1/reopened', data)
  },

  shipShipment(id) {
    return http.put('/shipments/v1/shipped', { id })
  },

  approveShipment(data) {
    return http.put('/shipments/v1/approved', data)
  },

  readyShipment(data) {
    return http.put('/shipments/v1/ready', data)
  },

  updateShipment(id, data) {
    return http.put(`/shipments/v1/${id}`, data)
  },

  findShipmentByCode(code) {
    return http.get(`/shipments/v1/code/${code}`)
  },

  traceCode(code) {
    return http.get(`/compass-ws-rest/trace/${code}`)
  },

  receiveShipment(data) {
    return http.put('/shipments/v1/received', data)
  },

  enableCodeRange(firstCode, lastCode, req) {
    return http.put(`/hierarchies/v1/nodetype/${firstCode}/${lastCode}`, req)
  },

  listRecalls(req) {
    return http.get('/recalls/v1', { params: req })
  },

  getRecall(id) {
    return http.get(`/recalls/v1/${id}`)
  },

  getRecallInventoryByLocation(id, req) {
    return http.get(`/recalls/v1/${id}/location/active`, { params: req })
  },

  recallCodes(data) {
    return http.post('/recalls/v1/analysis/code', data)
  },

  recallOrder(id, data) {
    return http.post(`/recalls/v1/analysis/order/${id}`, data)
  },

  recallSection(id, data) {
    return http.post(`/recalls/v1/analysis/section/${id}`, data)
  }
}



// WEBPACK FOOTER //
// ./src/service/apis/TrackNTrace.js